import React, { useEffect, useState } from 'react';
import { number, object, string } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import { getRegion } from '../../../../../../utils/Region';
import { getTranslation } from '../../../../../../utils/getTranslation';
import Utils, { keyReplaceMultText } from '../../../../../../utils/Utils';
import { deletePosterRecording } from '../../../../redux/actions/cms.actions';
import { setRecordingToPlay } from '../../../../../Player/actions/recordings/recordings.actions';
import { SUPPORTED_STREAM } from '../../../../../../constants';
import { showEpisodeContainer } from '../../../../../EpisodeContainer/redux/episodeContainer.actions';
import useMenuRedirect from '../../../../../Menu/hooks/useMenuRedirect';
import {
  setContentName,
  setContentType,
  showDeleteConfirmationModal,
  setDeleteCallback,
} from '../../../../redux/actions/deleteConfirmationModal.actions';
import { dataTimeCalculate } from '../ContainerRecordingBar/redux/recordingsBar.thunks';
import {PUSHTOHISTORY} from 'constants.js'

import './styles.scss';
import { useNavigate } from 'react-router-dom';

export const PosterRecording = ({
  contentInfo,
  node,
  index,
  carouselTitle,
  contentPosition,
}) => {
  // satates
  const [data, setData] = useState({});
  const translations = useSelector(
    state => JSON.parse(state?.metadata?.translations || '{}')?.language[getRegion()],
  );
  const { navigateToChannel, nodesSelected } = useMenuRedirect();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  // llaves asset
  const {
    content_data_option_button_delete, // btn eliminar
    content_playing_option_button_play, // btn play rojo
    content_data_option_button_seasons, // recuadro de num de episodios
    playing_playerControls_toolbar_button_recorded, // grabado icon
    playing_playerControls_toolbar_button_recordingBlink, // grabando y por grabar icon
    content_data_recordings_placeholder, // placeholder img
  } = useSelector(state => state?.asset);

  // llaves text
  const CONTENT_DATA_EPISODES_LABEL = 'content_data_episodes_label'; // Episodios
  const PANELOPTIONS_DESCRIPTION_PROGRAMDURATION_LABEL =
    'panelOptions_description_programDuration_label'; // {@hrs}hr {@min}min (no da respuesta)
  const RIBBON_FORMAT_HOUR_LABEL = 'ribbon_format_hour_label'; // {@hrs} hr
  const RIBBON_FORMAT_MINUTES_LABEL = 'ribbon_format_minutes_label'; // {@min} min
  const PLAYING_PLAYERCONTROLS_TOOLBAR_BUTTON_RECORDED =
    'playing_playerControls_toolbar_button_recorded'; // Grabado
  const PLAYING_PLAYERCONTROLS_TOOLBAR_BUTTON_RECORDINGBLINK =
    'playing_playerControls_toolbar_button_recordingBlink'; // Grabando
  const RECORDING_NPVR_TORECORD_LABEL = 'recording_npvr_toRecord_label'; // Por grabar

  // otras contsantes
  const INGESTED = 'ingested'; // grabado
  const RECORDING = 'recording'; // grabando
  const SCHEDULED = 'scheduled'; // po grabar

  // funciones para el render

  // funcion para el formato de duración y fecha.
  const durationFormatt = () => {
    try {
      const dateFormatt = `${moment(data?.date * 1000).format('ll')}`; // formato de la fecha
      const durationCalculate = moment?.duration(data?.duration * 1000); // de milisegundos a hrs con min
      const hrs = durationCalculate?.hours(); // opteniendo hrs
      const min = durationCalculate?.minutes(); // opteniendo min

      const replaceTextHr = [
        {
          text: '{@hrs}',
          newText: hrs,
        },
      ];

      const replacetextMin = [
        {
          text: '{@min}',
          newText: min,
        },
      ];

      const hrsFotmatt = keyReplaceMultText(
        RIBBON_FORMAT_HOUR_LABEL,
        translations,
        replaceTextHr,
      );

      const minFormmat = keyReplaceMultText(
        RIBBON_FORMAT_MINUTES_LABEL,
        translations,
        replacetextMin,
      );

      const formatt = `${hrsFotmatt} ${minFormmat} ${dateFormatt}`;
      return formatt;
    } catch (e) {
      console.error(e);
      return '';
    }
  };

  // funcion para numero de episodios
  const episodesFormatt = () => {
    return `${data?.numEpisodes} ${getTranslation(
      CONTENT_DATA_EPISODES_LABEL,
      translations,
    )}`;
  };

  // optener el texto segun el status
  const getTextStatus = () => {
    switch (data?.status) {
      case INGESTED: {
        return getTranslation(
          PLAYING_PLAYERCONTROLS_TOOLBAR_BUTTON_RECORDED,
          translations,
        );
      }

      case RECORDING: {
        return getTranslation(
          PLAYING_PLAYERCONTROLS_TOOLBAR_BUTTON_RECORDINGBLINK,
          translations,
        );
      }

      case SCHEDULED: {
        return getTranslation(RECORDING_NPVR_TORECORD_LABEL, translations);
      }

      default:
        return '';
    }
  };

  // optener el icono segun el status
  const getIconStatus = () => {
    if (data?.status === INGESTED) {
      return playing_playerControls_toolbar_button_recorded;
    }
    if (data?.status === RECORDING || data?.status === SCHEDULED) {
      return playing_playerControls_toolbar_button_recordingBlink;
    }

    return '';
  };

  // se debe mostrar el btn player
  const shouldShowThePlayButton = () => {
    if (data?.IsEvent && data?.status === INGESTED) {
      return true;
    }
    if (data?.IsEvent && data?.status === RECORDING) {
      return true;
    }
    return false;
  };

  // funciones para obtener/formatera los datos

  const isSerie = () => !!contentInfo?.serie_id;

  const getDataEvent = () => {
    const { channel, status, record_id, actions, pack_id, time_used } =
      contentInfo || {};
    const { date_begin, duration, ext_original_name, ext_eventimage_name } =
      channel?.event || {};

    const dataPoster = {
      id: record_id,
      IsEvent: true,
      img: ext_eventimage_name || content_data_recordings_placeholder,
      name: ext_original_name || '',
      date: date_begin || '',
      duration: duration || '',
      numEpisodes: null, // null por que un evento no tiene eposidios
      status: status || '',
      deleteURl: actions?.delete || '',
      group_id: channel?.group_id || null,
      pack_id: pack_id || null,
      time_used: time_used || null,
      // metricas
      title: ext_original_name || '',
      format_types: '',
      proveedor_code: '',
    };

    return dataPoster;
  };

  const getDataSerie = () => {
    const {
      image,
      serie_name,
      serie_id,
      records,
      actions,
      group_id,
      pack_id,
      time_used,
    } = contentInfo || {};
    const dataPoster = {
      id: serie_id,
      IsEvent: false,
      img: image || content_data_recordings_placeholder,
      name: serie_name || '',
      date: null, // null por que la portada de la serie no lleva fecha
      duration: null, // null por que la portada de la serie no lleva duracion
      numEpisodes: records?.length || '',
      status: null, // null por que la portada de la serie no lleva status
      deleteURl: actions?.delete || '',
      urlGetEpisodes: actions?.episodes || '',
      group_id: group_id || null,
      pack_id: pack_id || null,
      time_used: time_used || null,
      // metricas
      title: serie_name || '',
      format_types: '',
      proveedor_code: '',
    };
    return dataPoster;
  };

  const getDataPoster = () => {
    const is_Serie = isSerie();
    let dataPoster = {};
    if (is_Serie) {
      dataPoster = getDataSerie();
    } else {
      dataPoster = getDataEvent();
    }

    return dataPoster;
  };

  // funciones de eventos
  const handleDelete = async () => {
    dispatch(
      deletePosterRecording({
        data,
        node,
        index,
      }),
    );
  };

  const showModalDelete = event => {
    event.stopPropagation();

    const typePoster = isSerie() ? 'recording_serie' : 'recording_event';

    dispatch(setContentName(data?.name));
    dispatch(setContentType(typePoster));

    dispatch(
      setDeleteCallback(() => {
        dispatch(handleDelete);
      }),
    );

    dispatch(showDeleteConfirmationModal);
  };

  const handleShowPlayerEvent = () => {
    let url = '';
    const { channel, actions } = contentInfo;
    const idURL = channel?.group_id;
    const actionsRecording = { ...actions };
    const item = {
      isRecording: true,
      channel_id: contentInfo?.channel?.id,
      ...contentInfo?.channel?.event,
    };

    if (idURL) {
      const deviceSO = Utils.getDeviceOS();
      SUPPORTED_STREAM[deviceSO]?.forEach(value => {
        if (actionsRecording?.play?.[value]) {
          url = actionsRecording?.play?.[value];
        }
      });

      const recordingData = {
        item,
        url,
      };

      dispatch(
        setRecordingToPlay(recordingData, () => {
          navigate(`/${getRegion()}/watch/${channel?.group_id}`);
        }),
      );
    }
  };

  const handleEventPoster = event => {
    event.stopPropagation();
    if (data?.status === INGESTED) {
      // si esta en estatus grabado manda al player
      handleShowPlayerEvent();
    }
    if (data?.status === RECORDING) {
      // si esta en estatus grabando manda al canal en vivo
      navigateToChannel({ id: data?.group_id }, PUSHTOHISTORY);
      // navigateToChannel({ id: data?.group_id });
    }
  };

  const handleShowSeriesEpisodes = () => {
    const payload = {
      show: true,
      nameSerie: data?.name,
      urlGetEpisode: data?.urlGetEpisodes,
    };
    dispatch(showEpisodeContainer(payload));
  };

  const handelClickPoster = () => {
    pushSelectContentEvent(data, nodesSelected, carouselTitle, contentPosition);

    if (isSerie()) {
      dispatch(dataTimeCalculate(data));
      handleShowSeriesEpisodes();
    } else {
      dispatch(dataTimeCalculate(data));
    }
  };

  useEffect(
    () => {
      const dataPoster = getDataPoster();
      setData(dataPoster);
    },
    [contentInfo],
  );

  return (
    <div
      className={`posterRecording ${isSerie() ? 'posterRecordingCursor' : ''}`}
      onClick={handelClickPoster}
    >
      <figure className="posterRecording__figure">
        <img className="figure__img" src={data?.img} />
      </figure>
      <section className="posterRecording__inf">
        <section className="inf__description">
          <h3 className="description__title">{data?.name}</h3>
          {data?.IsEvent ? (
            <p className="description__time-episode">{durationFormatt()}</p>
          ) : (
            <div className="description__cont-episode">
              <img src={content_data_option_button_seasons} />
              <p className="cont-episode__text">{episodesFormatt()}</p>
            </div>
          )}

          <div className="description__type">
            <img className="type__icon" src={getIconStatus()} />
            <p className="type__text">{getTextStatus()}</p>
          </div>
        </section>
        <section
          className={`inf__controllers ${
            shouldShowThePlayButton() ? '' : ' justify-content-end'
          }`}
        >
          {shouldShowThePlayButton() && (
            <img
              className="controllers__play"
              onClick={event => handleEventPoster(event)}
              src={content_playing_option_button_play}
            />
          )}

          <img
            onClick={evet => showModalDelete(evet)}
            className="controllers__delete"
            src={content_data_option_button_delete}
          />
        </section>
      </section>
    </div>
  );
};

PosterRecording.propTypes = {
  contentInfo: object,
  node: string,
  index: number,
  carouselTitle: string,
};
